import { render, staticRenderFns } from "./Veggie-gourmand.vue?vue&type=template&id=8d2002cc&scoped=true&"
import script from "./Veggie-gourmand.vue?vue&type=script&lang=js&"
export * from "./Veggie-gourmand.vue?vue&type=script&lang=js&"
import style0 from "./Veggie-gourmand.vue?vue&type=style&index=0&id=8d2002cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2002cc",
  null
  
)

export default component.exports